export const oddsLabels = {
  '1x2': '1X2',
  'FIRST HALF': 'First half',
  'SECOND HALF': 'Second half',
  OVER_UNDER: 'Over/Under',
  DOUBLE_CHANCE: 'Double chance',
  BOTH_TO_SCORE: 'Both to score',
  DRAW_NO_BET: 'Draw No Bet',
  FIRST_TEAM_TO_SCORE: 'First team to score',
  CORRECT_SCORE: 'Correct score',
  FIRST_HALF_GOALS: 'First half goals',
  FIRST_PLAYER_TO_SCORE: 'First player to score',
  PLAYER_TO_SCORE_DURING_GAME: 'Player to score during game',
  PLAYER_TO_RECEIVE_CARD: 'Player to receive card',
  FIRST_HALF_AND_FINAL_RESULT: 'First half and final result',
  over: 'Over',
  under: 'Under',
  yes: 'Yes',
  no: 'No',
};

export const matchResultLabels = {
  win_short: 'W',
  win_overtime_short: 'W',
  win_after_penalty_short: 'W',
  draw_short: 'D',
  loss_short: 'L',
  loss_overtime_short: 'L',
  loss_after_penalty_short: 'L',
};

export const socialMediaLabels = {
  web: 'Official website',
  facebook: 'Facebook page',
  instagram: 'Instagram page',
  twitter: 'Twitter page',
  youtube: 'Youtube channel',
};

export const footballLineupsLabels = {
  first_team: 'Starting lineups',
  substitutes: 'Substitutes',
  no_data: 'No data to display',
  substituted_players: 'Substituted Players',
  formation: 'Formations',
};

export const footballLivescoreLabels = {
  ...oddsLabels,
  all: 'All',
  popular: 'Popular',
  upcoming: 'Upcoming',
  live: 'Live',
  finished: 'Finished',
  odds: 'Odds',
  no_games: 'No games',
  standings: 'Standings',
};

export const footballMatchesH2HLabels = {
  H2H: 'H2H',
  W: 'W',
  L: 'L',
  D: 'D',
};

export const footballMostDecoratedLabels = {
  name: 'Name',
  player: 'Player',
  first_yellow_cards_short: 'FYC',
  first_yellow_cards: 'First yellow',
  red_cards_short: 'RC',
  red_cards: 'Red',
  total_cards_short: 'TC',
  total_cards: 'All',
  yellow_cards_short: 'YC',
  yellow_cards: 'Yellow',
  most_decorated_player: 'Most decorated players',
  no_data: 'No data',
};

export const footballOddsLabels = {
  ...oddsLabels,
  no_odds: "No odds available. Please make sure you've selected an upcoming match.",
};

export const footballPlayerLabels = {
  ...oddsLabels,
  ...socialMediaLabels,
  ...matchResultLabels,
  player_bio: 'Player bio',
  position: 'Position',
  shirt_number: 'Shirt number',
  height: 'Height',
  weight: 'Weight',
  age: 'Age',
  player_stats: 'Player stats',
  played: 'Played',
  minutes: 'Minutes',
  yellow_cards: 'Yellow cards',
  red_cards: 'Red cards',
  goals: 'Goals',
  assists: 'Assists',
  shots: 'Shots',
  goals_substitute: 'Goals substitute',
  minutes_substitute: 'Minutes substitute',
  started: 'Started',
  substitute_in: 'Substitute in',
  substitute_out: 'Substitute out',
  cleansheets: 'Clean sheets',
  conceded: 'Conceded',
  caught_ball: 'Caught ball',
  penalty_goals: 'Penalty goals',
  own_goals: 'Own goals',
  shots_on_target: 'Shots on target',
  offsides: 'Offsides',
  fouls_committed: 'Fouls committed',
  penalties_committed: 'Penalties committed',
  penalties_saved: 'Penalties saved',
  penalties_missed: 'Penalties missed',
  penalties_received: 'Penalties received',
  saves: 'Saves',
  FORWARD: 'Forward',
  MIDFIELDER: 'Midfielder',
  DEFENDER: 'Defender',
  KEEPER: 'Keeper',
  weight_metric: 'kg',
  height_metric: 'cm',
};

export const footballPlayerH2HLabels = {
  vs: 'VS.',
  assists: 'Assists',
  cleansheets: 'Clean sheets',
  fouls_committed: 'Fouls committed',
  goals: 'Goals',
  goals_substitute: 'Goals substitute',
  minutes: 'Minutes',
  minutes_substitute: 'Minutes substitute',
  offsides: 'Offsides',
  own_goals: 'Own goals',
  penalties_committed: 'Penalties committed',
  penalties_missed: 'Penalties missed',
  penalties_received: 'Penalties received',
  penalties_saved: 'Penalties saved',
  penalty_goals: 'Penalty goals',
  played: 'Played',
  red_cards: 'Red cards',
  shots: 'Shots',
  shots_on_target: 'Shots on target',
  started: 'Started',
  substitute_in: 'Substitute in',
  substitute_out: 'Substitute out',
  yellow_cards: 'Yellow cards',
};

export const footballProgrammeLabels = {
  ...oddsLabels,
  current_season: 'Current season',
  fixtures: 'Fixtures',
  results: 'Results',
  standings: 'Standings',
};

export const footballRoundLabels = {
  ...oddsLabels,
  round: 'Round',
  standings: 'Standings',
};

export const footballSingleEventLabels = {
  ...oddsLabels,
  fu_win_question: 'Who will win?',
  fu_draw: 'Draw',
  fu_play_free: '',
  round: 'Round',
  in_regular_time: 'In regular time',
  after_penalties: 'After penalties',
  aggregate: 'Agg.',
  penalty_goal: 'P',
  own_goal: 'OG',
};

export const footballStakesLabels = {
  stakes_amount_description: 'With a {amount} bet',
  stakes_bet: 'Bet now',
  stakes_bet_on_team: 'Bet on your team to win!',
  stakes_currency: '€',
  stakes_payout: 'Payout',
  stakes_stake: 'Stake',
  vs: 'VS',
};

export const footballStandingsLabels = {
  team: 'Team',
  matches_won_short: 'MW',
  points_short: 'P',
  matches_played_short: 'MP',
  match_losses_short: 'L',
  match_draws_short: 'D',
  goal_difference_short: 'GD',
  team_form_short: 'F',
  team_form: 'TEAM FORM',
  matches_played: 'MATCHES PLAYED',
  goal_difference: 'GOAL DIFFERENCE',
  points: 'POINTS',
  matches_won: 'MATCHES WON',
  match_draw: 'MATCH DRAWS',
  match_losses: 'MATCH LOSSES',
  footer_win: 'Win',
  footer_loss: 'Loss',
  footer_draw: 'Draw',
};

export const footballTeamLabels = {
  ...(() => {
    const { over, under, yes, no, ...rest } = oddsLabels;
    return rest;
  })(),

  ...socialMediaLabels,
  ...matchResultLabels,
  team_stats: 'Team stats',
  played: 'Played',
  win: 'Win',
  goals_scored: 'Goals scored',
  goals_conceded: 'Goal conceded',
  draw: 'Draw',
  defeats: 'Defeats',
  rank: 'Rank',
  points: 'Points',
  est: 'Est',
};

export const footballTeamH2HLabels = {
  defeats: 'Defeats',
  draw: 'Draws',
  goals_conceded: 'Goals conceded',
  goals_scored: 'Goals scored',
  played: 'Played',
  win: 'Wins',
  points: 'Points',
  rank: 'Rank',
};

export const footballTeamMatchH2HLabels = {
  corners: 'Corners',
  counter_attacks: 'Counter attacks',
  crosses: 'Crosses',
  fouls_committed: 'Fouls committed',
  goal_kicks: 'Goal kicks',
  goals: 'Goals',
  offside: 'Offside',
  possession: 'Possession',
  red_cards: 'Red cards',
  shots_blocked: 'Shots blocked',
  shots_off: 'Shots off',
  shots_on: 'Shots on',
  substitutions: 'Substitutions',
  throw_in: 'Throw in',
  treatments: 'Treatments',
  yellow_cards: 'Yellow cards',
};

export const footballTeamSquadLabels = {
  list_view: 'List view',
  card_view: 'Card view',
  name: 'Name',
  age_short: 'Y',
  matches_played_short: 'P',
  minutes_short: 'Min',
  yellow_cards_short: 'YC',
  red_cards_short: 'RC',
  age: 'Years',
  matches_played: 'Matches played',
  minutes: 'Minutes',
  yellow_cards: 'Yellow cards',
  red_cards: 'Red cards',
  goalkeepers: 'GOALKEEPERS',
  defenders: 'DEFENDERS',
  midfielders: 'MIDFIELDERS',
  forwards: 'FORWARDS',
  goals_short: 'G',
  assists_short: 'A',
  minutes_substitute_short: 'MS',
  started_short: 'S',
  conceded_short: 'GC',
  cleansheets_short: 'CS',
  goals: 'Goals',
  assists: 'Assists',
  minutes_substitute: 'Minutes as substitute',
  started: 'Started',
  conceded: 'Conceded',
  cleansheets: 'Clean sheets',
};

export const footballTimelineLabels = {
  on_for: 'on for',
  assist_by: 'assist by',
  half_time: '1st half-time',
  finished_after_extra_time: 'finished after extra time',
  finished_after_penalties: 'finished after penalties',
  first_half_time_finish: '1st half-time',
  second_half_time_finish: '2nd half-time',
  game_starts: 'Game starts',
  no_events_yet: 'No events yet',
  minutes: 'min',
};

export const footballTopScorersLabels = {
  assists_short: 'ASS',
  assists: 'Assists',
  goals_short: 'G',
  goals: 'Goals',
  name: 'Name',
  player: 'Player',
  yellow_cards_short: 'YC',
  yellow_cards: 'Yellow cards',
  red_cards_short: 'RC',
  red_cards: 'Red cards',
  played_short: 'PL',
  played: 'Played',
  minutes_short: 'M',
  minutes: 'Minutes',
  missed_penalties_short: 'MP',
  missed_penalties: 'Missed penalties',
  penalties_short: 'P',
  penalties: 'Penalties',
  scored_first_short: 'SF',
  scored_first: 'Scored first',
  top_scores: 'Top scores',
  no_data: 'No data',
};

export const footballTournamentProgrammeLabels = {
  fixtures: 'Fixtures',
  results: 'Results',
  round: 'Round',
  ...oddsLabels,
  standings: 'Standings',
};

export const footballMatchCenterLabels = {
  ...footballSingleEventLabels,
  ...footballLineupsLabels,
  ...footballTeamMatchH2HLabels,
  ...footballStandingsLabels,
  ...footballTimelineLabels,
  match_information: 'MATCH INFORMATION',
  match_info_time: 'Date and time',
  match_info_venue: 'Venue',
  match_info_referee: 'Referee',
  match_info_spectators: 'Attendance',
  match_info_competition: 'Competition',
  match_information_tab: 'Information',
  match_timeline_tab: 'Timeline',
  match_statistics_tab: 'Statistics',
  match_standings_tab: 'Standings',
  match_playoff_tab: 'Playoff',
  match_odds_tab: 'Odds',
  match_h2h_tab: 'H2H',
};

export const playerStatisticLabels = {
  played: 'Played',
  saves: 'Saves',
  cleansheets: 'Clean sheets',
  conceded: 'Conceded',
  caught_ball: 'Caught ball',
  penalties_saved: 'Penalties saved',
  goals: 'Goals',
  assists: 'Assists',
  minutes: 'Minutes',
  started: 'Started',
  red_cards: 'Red cards',
  yellow_cards: 'Yellow cards',
  substitute_in: 'Substitute in',
  substitute_out: 'Substitute out',
  goals_substitute: 'Goals as substitute',
  minutes_substitute: 'Minutes as substitute',
  penalty_goals: 'Penalty goals',
  own_goals: 'Own goals',
  shots: 'Shots',
  shots_on_target: 'Shots on target',
  offsides: 'Offsides',
  fouls_committed: 'Fouls committed',
  penalties_committed: 'Penalties committed',
  penalties_missed: 'Penalties missed',
  penalties_received: 'Penalties received',
};

export const teamStatisticLabels = {
  played: 'Played',
  win: 'Win',
  goals_scored: 'Goals scored',
  goals_conceded: 'Goal conceded',
  draw: 'Draw',
  defeats: 'Defeats',
  rank: 'Rank',
  points: 'Points',
};

export const playoffLabels = {
  prev_stage_btn: 'Previous stage',
  next_stage_btn: 'Next stage',
};

export const iceHockeyLivescoreLabels = {
  all: 'All',
  upcoming: 'Upcoming',
  popular: 'Popular',
  live: 'Live',
  finished: 'Finished',
  odds: 'Odds',
  no_games: 'No games',
  overtime_short: 'OT',
  points_short: 'PTS',
  score_short: 'S',
  standings: 'Standings',
};

export const iceHockeySingleEventLabels = {
  ...oddsLabels,
  round: 'Round',
  in_regular_time: 'In regular time',
  after_penalties: 'After penalties',
  aggregate: 'Agg.',
};

export const iceHockeyStandingsLabels = {
  ...playoffLabels,
  percentages_short: 'PCT',
  team: 'Team',
  team_form: 'FORM',
  team_form_short: 'FORM',
  matches_won_short: 'W',
  matches_won: 'MATCHES WON',
  points_short: 'PTS',
  points: 'POINTS',
  matches_played_short: 'MP',
  matches_played: 'MATCHES PLAYED',
  match_losses_short: 'L',
  match_losses: 'MATCH LOSSES',
  points_difference_short: 'PD',
  points_difference: 'POINTS DIFFERENCE',
  percentages: 'PERCENTAGES',
  goals_difference_short: 'GD',
  goals_difference: 'GOAL DIFFERENCE',
  matches_losses_overtime: 'MATCH LOSSES OVERTIME',
  matches_losses_overtime_short: 'LO',
  matches_won_overtime_short: 'WO',
  matches_won_overtime: 'MATCHES WON OVERTIME',
  no_data: 'No standings data available',
  no_games: 'No games for the selected playoff',
  win_after_penalty: 'WIN AFTER PENALTY',
  win_after_penalty_short: 'WAP',
  loss_after_penalty: 'LOSS AFTER PENALTY',
  loss_after_penalty_short: 'LAP',
  win_overtime_short: 'WO',
  loss_overtime_short: 'LO',
};

export const basketballLivescoreLabels = {
  all: 'All',
  upcoming: 'Upcoming',
  popular: 'Popular',
  live: 'Live',
  finished: 'Finished',
  odds: 'Odds',
  no_games: 'No games',
  overtime_short: 'OT',
  points_short: 'PTS',
  score_short: 'S',
  standings: 'Standings',
};

export const basketballSingleEventLabels = {
  ...oddsLabels,
};

export const basketballStandingsLabels = {
  ...playoffLabels,
  percentages_short: 'PCT',
  team: 'Team',
  team_form: 'FORM',
  team_form_short: 'FORM',
  matches_won_short: 'W',
  points_short: 'P',
  matches_played_short: 'MP',
  match_losses_short: 'L',
  points_difference_short: 'PD',
  no_data: 'No standings data available',
  no_games: 'No games for the selected playoff',
  matches_played: 'MATCHES PLAYED',
  matches_won: 'MATCHES WON',
  match_losses: 'MATCH LOSSES',
  points_difference: 'POINTS DIFFERENCE',
  points: 'POINTS',
  percentages: 'PERCENTAGES',
};

export const basketballTeamProgrammeLabels = {
  current_season: 'Current season',
  fixtures: 'Fixtures',
  results: 'Results',
  overtime_short: 'OT',
  points_short: 'PTS',
  score_short: 'S',
  standings: 'Standings',
};

export const basketballTournamentProgrammeLabels = {
  fixtures: 'Fixtures',
  results: 'Results',
  round: 'Round',
  overtime_short: 'OT',
  points_short: 'PTS',
  score_short: 'S',
  standings: 'Standings',
};

export const tennisAthleteProgrammeLabels = {
  current_season: 'Current season',
  fixtures: 'Fixtures',
  results: 'Results',
  no_matches: 'No matches',
  round: 'Round',
  points_short: 'PTS',
  score_short: 'S',
  standings: 'Standings',
};

export const tennisLivescoreLabels = {
  all: 'All',
  popular: 'Popular',
  upcoming: 'Upcoming',
  live: 'Live',
  finished: 'Finished',
  odds: 'Odds',
  no_matches: 'No matches',
  points_short: 'PTS',
  score_short: 'S',
  standings: 'Standings',
};

export const tennisPlayoffWidgetLabels = {
  no_games: 'No games for the selected playoff',
};

export const tennisRankingLabels = {
  points_short: 'Pts.',
  nationality_short: 'Nat.',
  name: 'Name',
  points: 'Points',
  nationality: 'Nationality',
  show_more: 'Show more',
  no_data: 'No ranking data available',
};

export const tennisSingleEventLabels = {
  points_short: 'PTS',
  score_short: 'S',
  ...oddsLabels,
};

export const tennisTournamentProgrammeLabels = {
  fixtures: 'Fixtures',
  results: 'Results',
  matches: 'No matches',
  round: 'Round',
  points_short: 'PTS',
  score_short: 'S',
  standings: 'Standings',
};

export const multisportEventsLabels = {
  top_events: 'Top Events',
  final: 'Final',
  winner: 'Winner',
  football: 'Football',
  basketball: 'Basketball',
  tennis: 'Tennis',
  cycling: 'Cycling',
  handball: 'Handball',
  ice_hockey: 'Ice Hockey',
  motorsports: 'Motorsports',
  rugby_league: 'Rugby',
  cricket: 'Cricket',
  roller_hockey: 'Roller Hockey',
  age_restriction: 'WHAT DOES GAMBLING COST YOU? STOP ON TIME.',
};
